import React, { useState, useEffect, useContext } from 'react'
import Widget from '../../dpe-usco/components/Widget/Widget'
import add from '../../assets/icons/add.svg'
import close from '../../assets/icons/close.svg'
import { Modal, Button } from 'syngenta-react-components'
import { useForm, Controller } from 'react-hook-form'
import Select from '../../dpe-usco/components/Select/Select'
import Toast from '../../components/subComponents/Notifications/Toast'
import _ from 'lodash'
import clear from '../../assets/icons/clear.svg'
import Table from '../../dpe-usco/components/Table/Table'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { GlobalContext } from '../../services/context'

const headerContent = value => {
  return (
    <div key={value} className="cell df aic">
      <span className="cell">{value}</span>
    </div>
  )
}

const Storage = ({
  postStorageLocation,
  grower_id,
  contractDispatch,
  storageData,
  updateStorage,
  _defaultStorage,
  operationType
}) => {
  const { trackEvent } = useContext(GlobalContext)
  let [showModal, setShowModal] = useState(false)
  let [showToast, setShowToast] = useState(false)
  let [alertMessage, setAlertMessage] = useState('')
  const [options, setOptions] = useState([])
  const { control, register, errors, handleSubmit, reset, setValue } = useForm()
  const [tableData, setTableData] = useState([])
  const [storageCapacityUnit, setStorageCapacityUnit] = useState('Tons')
  
  useEffect(() => {
    if (storageData?.length && _defaultStorage?.size) {
      const newStorage = []
      storageData.forEach(location => {
        if (_defaultStorage.has(location.storage_locations_id)) {
          const obj = _defaultStorage.get(location.storage_locations_id)
          newStorage.push({ ...location, isChecked: true, storage_locations_capacity: obj.storage_capacity })
        } else {
          newStorage.push(location)
        }
      })
      setOptions(newStorage)
    } else if (storageData) {
      const _storageData = storageData.map(obj => {
        return { ...obj }
      })
      setOptions(_storageData)
    }
  }, [_defaultStorage, storageData])

  useEffect(() => {
    const updatedStorage = tableData
      .filter(storage => storage.isChecked)
      .map(filteredStorage => {
        return {
          storage_location_id: filteredStorage.storage_locations_id,
          storage_latitude: filteredStorage.storage_locations_latitude,
          storage_name: filteredStorage.storage_locations_name,
          storage_longitude: filteredStorage.storage_locations_longitude,
          storage_capacity: filteredStorage.storage_locations_capacity,
          storage_type: filteredStorage.storage_locations_type
        }
      })
    updateStorage({ type: 'UPDATE_STORAGE', payload: updatedStorage })
    if (updatedStorage.length !== 0) {
      updateStorage({
        type: 'CLEAR_ERROR',
        payload: { storage: { empty: false } }
      })
    }
  }, [tableData, updateStorage])

  const updateCheckbox = (rowContent, e) => {
    e.preventDefault()
    const filtered = options.map(optionsData => {
      if (
        optionsData.storage_locations_id === rowContent.storage_locations_id
      ) {
        trackEvent('storage_location_unchecked', {
          storageLocationId: rowContent.storage_locations_id
        })
        return {
          ...optionsData,
          isChecked: false
        }
      } else {
        return { ...optionsData }
      }
    })
    setOptions(filtered)
  }

  const updateStorageTable = (e, name)=> {
    const updateTable = tableData.map(row => (
      row.storage_locations_name === name 
        ? { ...row, 'storage_locations_capacity': e.target.value } 
        : row
    ))
    setTableData(updateTable)
  }

  const storageStructure = {
    headers: [
      {
        value: 'Name',
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Storage capacity',
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: '',
        format() {
          return <div key="blank" className="w50" />
        }
      }
    ],
    dataKeys: [
      'storage_locations_name',
      'storage_locations_capacity',
      'button'
    ],
    dropdownCallback: updateCheckbox,
    rowFormat: {
      storage_locations_capacity: {
        overwriteStyles: true,
        customStyle: 'flx1 mr10',
        allContent: true,
        format: storage => {
          return <input
            type="number"
            min="0"
            value={storage.storage_locations_capacity}
            onChange={e => updateStorageTable(e, storage.storage_locations_name)}
          />
        }
      },
      button: {
        customStyle: 'w50',
        overwriteStyles: true,
        allContent: true,
        format: storage => {
          return (
            <button className="bdnone bgc-white" onClick={e => updateCheckbox(storage, e)}>
              <img className="curp" src={clear} alt="remove row" />
            </button>
          )
        }
      }
    }
  }

  useEffect(() => {
    const filtered = options.filter(storage => storage.isChecked).map(storage => {
      let existedData = tableData.find(curr => curr.storage_locations_name === storage.storage_locations_name)
      return existedData ? existedData : storage
    })
    setTableData(filtered)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])

  const handleCheckboxChange = (event, storageLocationId) => {
    const isChecked = event.target.checked
    setOptions(prevOptions =>
      prevOptions.map(option => {
        if (option.storage_locations_id === storageLocationId) {
          trackEvent(
            `storage_location_${isChecked ? 'checked' : 'unchecked'}`,
            { storageLocationId }
          )
          return { ...option, isChecked }
        }
        return option
      })
    )
  }

  const onSubmit = data => {
    if (_.isEmpty(errors)) {
      data.grower_id = grower_id
      postStorageLocation(data).then(res => {
        setShowToast(true)
        if (res && !res.errors) {
          setAlertMessage('Storage location added')
          if (options) {
            setOptions([...options, res])
          } else {
            setOptions([res])
          }
        } else {
          setAlertMessage('Unable to add storage location')
        }
      })
      closeModalHandler()
      reset()
    }
  }

  const handleSelection = option => {
    setValue('storage_locations_type', option)

    switch (option) {
      case 'Grain':
        setStorageCapacityUnit('Bushels')
        break
      case 'Silage':
        setStorageCapacityUnit('Tons')
        break
      case 'Earlage':
        setStorageCapacityUnit('Tons')
        break
      case 'High moisture corn':
        setStorageCapacityUnit('Wet Bushels')
        break
      default:
        setStorageCapacityUnit('Tons')
    }

  }

  const openModalHandler = () => {
    trackEvent('new_storage_location_clicked')
    if (grower_id) {
      contractDispatch({
        type: 'CLEAR_ERROR',
        payload: { grower_details: { empty: false } }
      })
      setShowModal(true)
    } else {
      contractDispatch({
        type: 'SET_ERRORS',
        payload: { grower_details: { empty: true } }
      })
    }
  }

  const closeModalHandler = () => {
    setShowModal(false)
    setAlertMessage('')
  }

  let tableStatusPrompt = ''

  if (!grower_id) {
    if (operationType === 'amend') {
      if (storageData.length === 0 && options.length === 0) {
        tableStatusPrompt = 'no storage'
      } else if (tableData.length === 0) {
        tableStatusPrompt = 'please select a storage location'
      }
    } else {
      tableStatusPrompt = 'select a grower to view and select storage'
    }
  } else if (storageData.length === 0 && options.length === 0) {
    tableStatusPrompt = 'selected grower has no storage'
  } else if (tableData.length === 0) {
    tableStatusPrompt = 'please select a storage location'
  }

  
  return (
    <Widget
      dataTestId="storageLocations"
      title="Storage locations"
      button={
        <button className="bdnone m0 bgc-t fz16 c-darkgray curp" onClick={openModalHandler}>
          <img className="pr10" src={add} alt="plus sign" /> New storage
          location
        </button>
      }
    >
      {showToast && <Toast message={alertMessage} />}

      <form onSubmit={onSubmit}>
        <div className="df mt25 mb20">
          <div className="df pt10 pr20 pl20 fxdrc mr25 mah600 bd1-s-lightgray bdrs-4 miw200 oys">
            {options.map(option => {
              return (
                <div key={option.storage_locations_id} className="df tal mb10 aic">
                  <input
                    id={option.storage_locations_id}
                    className="w10% mr10"
                    type="checkbox"
                    checked={!!option.isChecked}
                    onChange={event => handleCheckboxChange(event, option.storage_locations_id)}
                  />
                  <label htmlFor={option.storage_locations_id} className="w100% tal fz18">
                    {option.storage_locations_name}
                  </label>
                </div>
              )
            })}
          </div>
          <div className="flx1 mah700">
            <Table
              data={tableData}
              structure={storageStructure}
              statusComponent={
                tableStatusPrompt ? (
                  <TableStatus status="EMPTY" prompt={tableStatusPrompt} />
                ) : null
              }
            />
          </div>
        </div>
      </form>
      <Modal
        customClassName="bgc-white"
        autoHeight
        show={showModal}
        handleClose={() => {
          setShowModal(prev => !prev)
        }}
      >
        <div
          data-testid="modalParent"
          className="w800 h530 bgc-white bd1-s-lightgray bdrs-4"
        >
          <div className="df jcsb bb1-s-lightgray">
            <div className="fz16 fw600 p16">Add new storage</div>
            <div className="p16 curp">
              <img
                src={close}
                alt="close button"
                onClick={closeModalHandler}
              ></img>
            </div>
          </div>
          <div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="pt20 h400 bgc-white"
            >
              <div className="df">
                <div className="w50% p15">
                  <label htmlFor="storage_locations_name">
                    Name of storage location*
                  </label>
                  <input
                    className="bd1-s-lightgray mt4 lh1.5 fz15"
                    type="text"
                    id="storage_locations_name"
                    name="storage_locations_name"
                    ref={register({ required: true })}
                  />
                  <div className="c-red tal fz13 mt5">
                    {errors.storage_locations_name &&
                      errors.storage_locations_name.type === 'required' &&
                      'Name of storge location is required. Please complete this field'}
                  </div>
                </div>
                <div className="w50% p15">
                  <div className="mb5">
                    <label htmlFor="storage_locations_type">
                      Type of end product
                    </label>
                  </div>
                  <Controller
                    as={<Select />}
                    options={[
                      'Grain',
                      'Silage',
                      'Earlage',
                      'High moisture corn'
                    ]}
                    control={control}
                    id="storage_locations_type"
                    name="storage_locations_type"
                    handleSelection={handleSelection}
                  />
                </div>
              </div>
              <div className="df">
                <div className="w50% p15">
                  <label htmlFor="storage_locations_capacity">
                    Storage capacity*
                  </label>
                  <input
                    className="bd1-s-lightgray mt4 lh1.5 fz15"
                    type="number"
                    id="storage_locations_capacity"
                    name="storage_locations_capacity"
                    ref={register({ required: true })}
                  />
                  <div className="posr b32 l250 w100 fz16 tar">{storageCapacityUnit}</div>
                  <div className="c-red tal fz13 mt-20">
                    {errors?.storage_locations_capacity?.type === 'required' &&
                      'Capacity of storge location is required. Please complete this field'}
                  </div>
                </div>
                <div className="w50% p15">
                  <label htmlFor="storage_locations_latitude">
                    Storage latitude*
                  </label>
                  <input
                    className="bd1-s-lightgray mt4 lh1.5 fz15"
                    type="number"
                    id="storage_locations_latitude"
                    name="storage_locations_latitude"
                    ref={register({
                      required: true,
                      validate: {
                        valid: value => value > -90 && value < 90
                      }
                    })}
                  />
                  <div className="c-red tal fz13 mt5">
                    {errors?.storage_locations_latitude?.type === 'required' &&
                      'Latitude of storge location is required. Please complete this field'}
                    {errors?.storage_locations_latitude?.type === 'valid' &&
                      'Please provide a lattitude between -90 and 90'}
                  </div>
                </div>
              </div>
              <div className="df">
                <div className="w50% pl15 pb15 pr15">
                  <label htmlFor="storage_locations_longitude">
                    Storage longitude*
                  </label>
                  <input
                    className="bd1-s-lightgray mt4 lh1.5 fz15"
                    type="number"
                    id="storage_locations_longitude"
                    name="storage_locations_longitude"
                    ref={register({
                      required: true,
                      validate: {
                        valid: value => value > -180 && value < 180
                      }
                    })}
                  />
                  <div className="c-red tal fz13 mt5">
                    {errors?.storage_locations_longitude?.type === 'required' &&
                      'Longitude of storge location is required. Please complete this field'}
                    {errors?.storage_locations_longitude?.type === 'valid' &&
                      'Please provide a longitude between -180 and 180'}
                  </div>
                </div>
              </div>
            </form>
            <div className="bt1-s-lightgray">
              <div className="p15 flr">
                <Button
                  text="Cancel"
                  backgroundColor="white"
                  clickHandler={closeModalHandler}
                  textColor="#238661"
                  customClassName="bd1-s-green mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
                ></Button>
                <Button
                  type="success"
                  text="Save location"
                  clickHandler={handleSubmit(onSubmit)}
                  customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Widget>
  )
}

export default Storage
